import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "animate.css";
import "./App.css";
import "aos/dist/aos.css"; // Import AOS styles

import NotFoundPage from "./PAGES/404";
import HomePage from "./PAGES/HOME";
import ContactPage from "./PAGES/CONTACT";
import LocationsPage from "./PAGES/LOCATIONS";
import ScreeningPage from "./PAGES/SCREENING";
import AboutUs from "./PAGES/ABOUTUS";
import PartnerWithUs from "./PAGES/PARTNERWITHUS";

function App() {
  return (
    <div className="app-container" style={{ width: "100%" }}>
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/home" element={<HomePage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/screening_program" element={<ScreeningPage />} />
          <Route path="/about_us" element={<AboutUs />} />
          <Route path="/partner_us" element={<PartnerWithUs />} />
          
          {/* <Route
            path="/locations/texas"
            element={<LocationsPage state="texas" />}
          />
          <Route
            path="/locations/oklahoma"
            element={<LocationsPage state="oklahoma" />}
          />
           */}
            <Route path="/locations" element={<LocationsPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
